import { FYOption } from '../types';
import { getFyEndYear } from './formatFyLabel';

export type SavedNewFyPreference = {
  fromFy: number;
  toFy: number;
  option: FYOption;
  startYear: number;
  endYear: number;
};

export const serializeNewFyPreference = ({
  fromFy,
  toFy,
  option,
  startYear,
  endYear,
}: SavedNewFyPreference): string => `${fromFy}|${toFy}|${option}|${startYear}|${endYear}`;

export const parseNewFyPreference = (additionalvalue: string | null | undefined): SavedNewFyPreference | null => {
  if (!additionalvalue) return null;

  if (additionalvalue.includes('|')) {
    const [fromFyStr, toFyStr, option, startYearStr, endYearStr] = additionalvalue.split('|');
    const startYear = Number(startYearStr);
    const endYear = Number(endYearStr);
    if (!fromFyStr || !toFyStr || !option || !startYear || !endYear) return null;
    if (option !== 'CALENDAR' && option !== 'FINANCIAL') return null;

    return {
      fromFy: Number(fromFyStr),
      toFy: Number(toFyStr),
      option,
      startYear,
      endYear,
    };
  }

  const parts = additionalvalue.split('-');
  if (parts.length < 5) return null;

  const endYear = Number(parts[parts.length - 1]);
  const startYear = Number(parts[parts.length - 2]);
  const option = parts[parts.length - 3];
  const toFy = Number(parts[parts.length - 4]);
  const fromFy = Number(parts.slice(0, parts.length - 4).join('-'));

  if (!fromFy || !toFy || !startYear || !endYear) return null;
  if (option !== 'CALENDAR' && option !== 'FINANCIAL') return null;

  return {
    fromFy,
    toFy,
    option,
    startYear,
    endYear,
  };
};

export const getFyYearsFromSelection = (
  selectedYear: number,
  fyOption: FYOption
): { startYear: number; endYear: number } => ({
  startYear: selectedYear,
  endYear: getFyEndYear(selectedYear, fyOption),
});
